import { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, CircularProgress } from "@mui/material";

const DeleteProductConfirm = ({ open, onClose, onConfirm, product }) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) {
      setSubmitting(false);
      setError(null);
    }
  }, [open]);

  const handleDelete = async () => {
    if (!product || !product.id) return;
    setError(null);
    try {
      setSubmitting(true);
      await onConfirm(product.id);
      // parent should close dialog on success
    } catch (err) {
      const serverData = err?.response?.data || err?.original?.response?.data;
      if (serverData) {
        const msgs = [];
        if (serverData.message) msgs.push(serverData.message);
        if (serverData.errors && typeof serverData.errors === "object") {
          Object.values(serverData.errors).forEach((v) => {
            if (Array.isArray(v)) msgs.push(...v);
            else msgs.push(v);
          });
        }
        setError(msgs.length ? msgs.join(" | ") : (err?.message || "Error deleting product"));
      } else {
        setError(err?.message || "Error deleting product");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !submitting && onClose && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle>تأكيد الحذف</DialogTitle>
      <DialogContent>
        <Typography>
          {product ? `هل أنت متأكد من حذف المنتج: "${product.name_ar || product.name_en || product.id}"؟` : "هل أنت متأكد من الحذف؟"}
        </Typography>
        {error ? <Typography color="error" sx={{ mt: 1 }}>{error}</Typography> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => !submitting && onClose && onClose()}>إلغاء</Button>
        <Button color="error" variant="contained" onClick={handleDelete} disabled={submitting}>
          {submitting ? <CircularProgress size={18} /> : "حذف"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteProductConfirm;
